module.exports = __webpack_public_path__ + "img/badge-icon.531cadac.svg";